import { useNavigate } from "react-router-dom";
import { ArrowLeftIcon } from "@heroicons/react/24/solid";
import Button, { EButtonColor, EButtonVariant } from "components/elements/Button";
import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";
import classes from "./classes.module.scss";

export default function ReturnButton() {
	const navigate = useNavigate();

	return (
		<div className={classes["root"]}>
			<Button variant={EButtonVariant.TEXT} color={EButtonColor.PRIMARY} startIcon={<ArrowLeftIcon />} onClick={() => navigate(-1)}>
				<Typography type="p" weight="bold" color="inherit">
					{I18n.asset.pages.post.return}
				</Typography>
			</Button>
		</div>
	);
}
